"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    translate: {},
    menu: {},
    settings: {}
};


//////////////////
// WEBPACK FOOTER
// ./~/d2-ui/lib/header-bar/dhis2.js
// module id = 104
// module chunks = 0